import React from 'react';

const CruiseDataCard = ({ cruiseCardData, onBookNowClick }) => (
  <div className="cruiseListing">
    <div className="HolidayCardSlider">
      {cruiseCardData.map((cruise, index) => (
        <div className="container">
          <div className="sliderImg" key={index}>
            <div className="containerImage">
              <img src={cruise.card.imgUrl} alt={cruise.card.cardHeader} />
              <div className="imageHead">
                <h2 className="slideItem">{cruise.card.cardHeader}</h2>
                <p className="head">{cruise.card.destination}</p>
              </div>
            </div>
          </div>
          <div className="slideBody">
            <div className="textSection">
              <h3 className="title">{cruise.subcard.title}</h3>
              <h4>{cruise.subcard.departureCity}</h4>
              {cruise.subcard.route.map((route, index) => (
                <div className="routesInfo" key={index}>
                  <img
                    className="locationIcon"
                    src="https://hldak.mmtcdn.com/prod-s3-hld-hpcmsadmin/holidays/images/phonixImages/cruise-location-090823.png"
                  />
                  <div className="locationName">{route.destination}</div>
                </div>
              ))}
            </div>
            <div className="bottomSection">
              <div className="pricingSection">
                <div className="durationText">{cruise?.subcard?.priceTag}</div>
                <div className="startingText">{cruise.subcard.text}</div>
                <div className="price">{cruise.subcard.price}</div>
              </div>
              <div className="button">
                <span className="primaryBtn" onClick={onBookNowClick}>
                  BOOK NOW
                </span>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default CruiseDataCard;
